import { useState, useEffect } from 'react';
import { Button, Modal, Form, ListGroup, OverlayTrigger, Tooltip } from 'react-bootstrap';
import API from '../../../Services/API';
import { toast } from 'react-hot-toast';
import { Link } from 'react-router-dom';
import { useDispatch } from 'react-redux';
import { loaderActions } from '../../../features/Loader/LoaderSlice';
import { useCurrentCompanyID } from '../../../hooks/useCurrentCompany';
import { filterOrdersForVendor } from '../../../Helpers/transferOrderFilters';

function AdvanceHeadersSearch(props) {
  const [modalShow, setModalShow] = useState(false);
  const [search, setSearch] = useState(props.query.trim());
  const [field, setField] = useState('docNo');
  const [orders, setOrders] = useState([]);
  const companyId = useCurrentCompanyID();

  const dispatch = useDispatch();

  async function searchOrder() {
    if (search.trim() !== '') {
      let url = '';
      let filter = '';
      if (props.type === 'purchase') {
        url = 'purchase_order_header';
        let vendorConfirmationFilter = '';
        let vendorFilter = '';
        if (props.vendorType === 'Warehouse') {
          vendorFilter = `whseVendorCode eq '${props.vendorNo}'`;
        } else {
          vendorConfirmationFilter = ' and vendConfirmationSent eq true';
          vendorFilter = `vendorNo eq '${props.vendorNo}'`;
        }
        filter = `${vendorFilter} ${vendorConfirmationFilter} and contains(${field},'${search}')`;
      } else {
        url = 'transfer_order_header';
        filter = `whseVendorCode eq '${props.vendorNo}' and contains(${field},'${search}')`;
      }

      const params = {
        company_id: companyId,
        $filter: filter
      };
      dispatch(loaderActions.show());
      const res = await API().get(`/${url}`, { params });
      const results = filterOrdersForVendor(res.data.value, props.type);
      if (results.length > 0) {
        setOrders(results);
      } else {
        setOrders([]);
        toast.error('No order found', { id: 'search' });
      }
      dispatch(loaderActions.hide());
    } else {
      setOrders([]);
      toast.error(`Please enter ${props.type === 'purchase' ? 'PO' : 'TO'} #`, { id: 'search' });
    }
  }
  const ordersList = orders.map((order, index) => {
    if (props.type === 'purchase') {
      return (
        <Link to={`/purchase-order/${props.vendorType}/${order.docNo}`} key={index} target="_blank">
          <ListGroup.Item>#{order.docNo}</ListGroup.Item>
        </Link>
      );
    } else {
      return (
        <Link to={`/transfer-order/${props.vendorType}/${order.docNo}`} key={index} target="_blank">
          <ListGroup.Item>#{order.docNo}</ListGroup.Item>
        </Link>
      );
    }
  });

  useEffect(() => {
    async function updateSearch() {
      if (modalShow === true && props.query !== '') {
        await searchOrder();
      }
    }
    updateSearch();
  }, [modalShow]);

  useEffect(() => {
    async function updateSearch() {
      if (modalShow === true && props.query !== '') {
        setSearch(props.query);
      }
    }
    updateSearch();
  }, [props]);

  return (
    <>
      <OverlayTrigger
        key="upload"
        className="mr-2 "
        placement={'top'}
        overlay={
          <Tooltip id={`tooltip-upload`} role={'button'}>
            Advanced Search
          </Tooltip>
        }
      >
        <i
          className="feather icon-search ml-2 mt-2"
          type="button"
          onClick={() => setModalShow(true)}
        />
      </OverlayTrigger>
      <Modal
        show={modalShow}
        onHide={() => setModalShow(false)}
        size="lg"
        aria-labelledby="contained-modal-title-vcenter"
        centered
      >
        <Modal.Header closeButton>
          <Modal.Title id="contained-modal-title-vcenter">Advanced search</Modal.Title>
        </Modal.Header>

        <Modal.Body>
          <Form.Group controlId="exampleForm.ControlSelect1">
            <Form.Label>Search Field</Form.Label>
            <Form.Control
              as="select"
              onChange={(e) => {
                setField(e.target.value);
              }}
            >
              <option value={'docNo'}>{props.type === 'purchase' ? 'PO' : 'TO'} #</option>
              <option value={props.type === 'purchase' ? 'vndrShpmntNo' : 'externalDocumentNo'}>
                External Doc #
              </option>
            </Form.Control>
          </Form.Group>
          <p>
            Please enter {props.type === 'purchase' ? 'PO' : 'TO'}{' '}
            {field === 'docNo' ? '#' : 'External Doc #'} to search
          </p>
          <Form.Control
            size="sm"
            type="text"
            className="mr-2"
            placeholder={`Enter Search #`}
            value={search}
            onChange={(e) => setSearch(e.target.value)}
          />
          {orders.length > 0 ? (
            <div className="mt-2">
              <p>Following orders found matching your search</p>
              <ListGroup>{ordersList}</ListGroup>
            </div>
          ) : (
            <></>
          )}
        </Modal.Body>
        <Modal.Footer>
          <Button onClick={() => searchOrder()}>Search</Button>
        </Modal.Footer>
      </Modal>
    </>
  );
}

export default AdvanceHeadersSearch;
